import Utils from "@/utils/utils"

export default {
  throttlingCoolDownTime: Utils.seconds(1)
}
